module.exports = __webpack_public_path__ + "img/clients1-717.ec03975.png";